/* eslint-disable arrow-body-style */
import { connect } from 'react-redux';
import accountDetails from '../../components/Blades/AccountDetails/AccountDetails';
import { RootState } from '../../stores';
import { closeModalActions } from '../../stores/closeModal/closeModalActions';
import { confirmationModalActions } from '../../stores/confirmationModal/confirmationModalActions';
import { visibilityActions } from '../../stores/visibility/visibilityActions';
import { getFormState } from '../../stores/form/formSelector';
import { formActions } from '../../stores/form/formActions';

const mapStateToProps = (state: RootState) => {
  return {
    formInitialState: getFormState(state),
  };
};

const mapDispatchToProps = {
  completed: visibilityActions.bladeComplete,
  closeModalOpen: closeModalActions.open,
  confirmationModalOpen: confirmationModalActions.open,
  focusDisplay: (toblade: string) => visibilityActions.bladeChangeFocus(toblade),
  formUpdated: formActions.updated,
  formSubmited: (formState: any) => formActions.submited(formState),
  confirmationModalData: formActions.updated,
  confirmationModalDataSubmit: (formSData: any) => formActions.submited(formSData),
};

export default connect(mapStateToProps, mapDispatchToProps)(accountDetails);
